import { FC, PropsWithChildren, useCallback, useEffect, useState } from 'react'
import CollapseCard from '@/components/CollapseCard'
import Table from './Table'
import * as api from '@/api/workbench'

type PropType = FC<PropsWithChildren<{
  className?: string
  count: any
}>>

const MyEntrust: PropType = ({ className }) => {
  const [count, setCount] = useState(0)

  // 获取统计数据
  const getCount = useCallback(async (params) => {
    const res = await api.getMyEntrustCount(params)
    if(res.success) {
      setCount(res.data && res.data.CNT_WDSP_DSH || 0)
    }
  }, [])

  return (
    <CollapseCard
      title="审批类-我的审批"
      className={className}
      items={
        [
          {label: `待审核（${count}）`, key: 'dsh', children: <Table type="待审核" onFlushCount={getCount} />},
          {label: '已审核', key: 'ysh', children: <Table type="已审核" />},
        ]
      }
    />
  )
}

export default MyEntrust
